package com.eladfinish.bible.contest.screens.search.api

import com.eladfinish.bible.contest.domain.catalog.BibleCatalog
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class RootReference(
    @SerialName("b") val book: Int,
    @SerialName("c") val chapter: Int,
    @SerialName("v") val verse: Int,
    @SerialName("w") val wordIndexes: List<Int>,
)

/** A verse with a date (elfifo4/dates-in-bible). [day] is only present in a month's all.json. */
@Serializable
data class DateReference(
    @SerialName("b") val book: Int,
    @SerialName("c") val chapter: Int,
    @SerialName("v") val verse: Int,
    @SerialName("d") val day: Int? = null,
    @SerialName("w") val wordIndexes: List<Int>,
)

/** {month}/{day}.json or {month}/all.json (no "day") of elfifo4/dates-in-bible. */
@Serializable
data class DateResult(
    @SerialName("month") val month: Int,
    @SerialName("day") val day: Int? = null,
    @SerialName("total") val total: Int,
    @SerialName("diff_verses") val diffVerses: Int,
    @SerialName("list") val verses: List<DateReference>,
)

@Serializable
data class RootResult(
    @SerialName("root") val root: String,
    @SerialName("total") val total: Int,
    @SerialName("diff_verses") val diffVerses: Int,
    @SerialName("list") val verses: List<RootReference>,
)

@Serializable
data class NumberReference(
    @SerialName("b") val book: String,
    @SerialName("c") val chapter: String,
    @SerialName("v") val verse: String,
    @SerialName("t") val content: String,
    @SerialName("i") val info: String = "",
) {
    val bookAsNumber: Int
        get() = BibleCatalog.books.indexOfFirst { it.hebrew == book }

}

@Serializable
data class NumberResult(
    @SerialName("times") val times: Int,
    @SerialName("verses") val verses: List<NumberReference>,
)
